import { useLocationStore } from '@/features/location/store/location-store';
import { useGoogleMapsStore } from '@/features/map/store/google-maps-store';
import { MIN_ZOOM, MAX_ZOOM } from '@/utils/constants';

/**
 * Zoom in/out buttons for the map
 */
export function ZoomButtons() {
  const zoomLevel = useLocationStore((s) => s.zoomLevel);
  const mapInstance = useGoogleMapsStore((s) => s.mapInstance);

  const handleZoomIn = () => {
    if (mapInstance && zoomLevel < MAX_ZOOM) {
      mapInstance.setZoom(zoomLevel + 1);
    }
  };

  const handleZoomOut = () => {
    if (mapInstance && zoomLevel > MIN_ZOOM) {
      mapInstance.setZoom(zoomLevel - 1);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <button
        onClick={handleZoomIn}
        disabled={zoomLevel >= MAX_ZOOM}
        className="surface-float w-11 h-11 rounded-full flex items-center justify-center hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed transition-transform"
        aria-label="Zoom in"
      >
        <svg
          className="w-5 h-5 text-ink"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4v16m8-8H4"
          />
        </svg>
      </button>
      <button
        onClick={handleZoomOut}
        disabled={zoomLevel <= MIN_ZOOM}
        className="surface-float w-11 h-11 rounded-full flex items-center justify-center hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed transition-transform"
        aria-label="Zoom out"
      >
        <svg
          className="w-5 h-5 text-ink"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20 12H4"
          />
        </svg>
      </button>
    </div>
  );
}
